import { TradeType } from '@eih-netbroker/common';
import { ButtonBase } from '@mui/material';
import { useLocale } from '../../../context/NbLocalizationContext';
import { cssWhen } from '../../utils/themeUtils';
import classes from './TradeTypeSwitch2.module.scss';

export type TradeTypeSwitch2Props = {
  className?: string;
  selectedValue?: TradeType;
  onChange: (value: TradeType) => void;
  disabled?: boolean;
  readOnly?: boolean;
};

export const TradeTypeSwitch2 = ({ className, selectedValue, onChange, disabled, readOnly }: TradeTypeSwitch2Props) => {
  const { translation } = useLocale();

  const handleClick = (value: TradeType) => {
    if (readOnly || disabled || value === selectedValue) {
      return;
    }
    onChange(value);
  };

  return (
    <div
      className={cssWhen(
        classes.tradeTypeSwitch,
        className,
        [selectedValue === TradeType.Buy, classes.tradeTypeSwitchIsBuyActive],
        [selectedValue === TradeType.Sell, classes.tradeTypeSwitchIsSellActive],
        [disabled, classes.tradeTypeSwitchIsDisabled],
      )}
    >
      <ButtonBase
        className={cssWhen(classes.tradeTypeSwitchButton, [
          selectedValue === TradeType.Buy,
          classes.tradeTypeSwitchButtonIsActive,
        ])}
        onClick={() => handleClick(TradeType.Buy)}
        data-testid="order-trade-type-buy-button"
        disabled={disabled}
        disableRipple
      >
        {translation.orderModal.buy}
      </ButtonBase>
      <ButtonBase
        className={cssWhen(classes.tradeTypeSwitchButton, [
          selectedValue === TradeType.Sell,
          classes.tradeTypeSwitchButtonIsActive,
        ])}
        onClick={() => handleClick(TradeType.Sell)}
        data-testid="order-trade-type-sell-button"
        disabled={disabled}
        disableRipple
      >
        {translation.orderModal.sell}
      </ButtonBase>
    </div>
  );
};
